export default "__VITE_ASSET__CuUO9tEZ__";